/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateShoreDto } from '../../models/create-shore-dto';
import { Shore } from '../../models/shore';

export interface CreateOneBaseMgmtShoreControllerShore$Params {
      body: CreateShoreDto
}

export function createOneBaseMgmtShoreControllerShore(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtShoreControllerShore$Params, context?: HttpContext): Observable<StrictHttpResponse<Shore>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtShoreControllerShore.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Shore>;
    })
  );
}

createOneBaseMgmtShoreControllerShore.PATH = '/api/mgmt/shore';
